/* 
首页接口
*/
import request from '@/utils/request'
import base from './base';

// host = 路由地址
export const host = base.api_data;


const api_contract_search = '/finance/search/';// 合同查询
const api_contract_check = '/finance/contract_check/';// 合同校验
const api_contract_action = '/finance/action/';// 查找合同id
const api_contract_save = '/finance/save/';// 新增和修改合同
const api_contract_upload_image = '/finance/contract_upload_image/';// 合同上传图片
const api_contract_batch_add = '/finance/batch_add/';// 批量添加合同             文件需要应用这个
const api_contract_uploadimage = '/finance/uploadImage/'; // 合同上传图片

const api_contract_template = '/finance/template/'; // 下载模板      文件需要应用这个
//水电费
const api_utilities_list = '/finance/utilities_expense/utilities/'; // 水电费列表
const api_utilities_detail = '/finance/utilities_expense/utilities/detail'; // 水电费账户详情
const api_utilities_payment_list = '/finance/utilities_expense/utilities/payment'; // 水电费缴费记录
const api_utilities_check = '/finance/utilities_expense/utilities/utilities_check'; // 注意添加末尾的斜杠
const api_utilities_save = '/finance/utilities_expense/utilities/save'; // 保存水电费账户
const api_utilities_action = '/finance/utilities_expense/utilities/action'; // 删除水电费账户
const api_utilities_template = '/finance/utilities_expense/utilities/template/'; // 下载模板
const api_utilities_batch_add = '/finance/utilities_expense/utilities/batch_add/'; // 批量添加
const api_utilities_payment_save = '/finance/utilities_expense/utilities/payment/save'; // 保存缴费记录
const api_utilities_payment_action = '/finance/utilities_expense/utilities/payment/action'; // 缴费记录操作
const api_utilities_payment_template = '/finance/utilities_expense/utilities/payment/template/'; // 下载缴费记录模板
const api_utilities_payment_batch_add = '/finance/utilities_expense/utilities/payment/batch_add/'; // 批量添加缴费记录


//定义方法
export default {
    baseurl: host,

    api_contract_search(params) {
        return request.post(`${host}${api_contract_search}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    api_contract_check(params) {
        return request.post(`${host}${api_contract_check}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    //新增和修改合同
    api_contract_save(params) {
        return request.post(`${host}${api_contract_save}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },

    api_contract_upload_image(params) {
        return request.post(`${host}${api_contract_upload_image}`, JSON.stringify(params), { headers: { 'Content-Type': 'multipart/form-data' } });
    },

    api_contract_action(params, method = 'delete') {
        if (method === 'DELETE') {
            return request.delete(`${host}${api_contract_action}`, { data: params });
        } else {
            const queryString = Object.entries(params)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');
            return request.get(`${host}${api_contract_action}?${queryString}`);
        }
    },
    api_contract_batch_add(formData) {
        return request.post(`${host}${api_contract_batch_add}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    api_contract_uploadimage(params) {
        console.log("打印参数--finance.js", params);
        //return request.post(`${host}${api_contract_uploadimage}`, params);
        return request.post(`${host}${api_contract_uploadimage}`, params, { headers: { 'Content-Type': 'multipart/form-data' } });
        //  return request.(`${host}${api_contract_uploadimage}`, params);
    },
    api_contract_template() {
        return request.get(`${host}${api_contract_template}`, {
            responseType: 'blob'
        });
    },
    api_utilities_list(params) {
        return request.post(`${host}${api_utilities_list}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    api_utilities_detail(params) {
        return request.get(`${host}${api_utilities_detail}`, { params });
    },
    api_utilities_save(params, method = 'POST') {
        if (method === 'PUT') {
            return request.put(`${host}${api_utilities_save}`, JSON.stringify(params), {
                headers: { 'Content-Type': 'application/json' }
            });
        }
        return request.post(`${host}${api_utilities_save}`, JSON.stringify(params), {
            headers: { 'Content-Type': 'application/json' }
        });
    },
    api_utilities_payment_list(params) {
        return request.get(`${host}${api_utilities_payment_list}`, { params });
    },
    api_utilities_action(params, method = 'get') {
        if (method === 'DELETE') {
            return request.delete(`${host}${api_utilities_action}`, {
                data: JSON.stringify(params),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        } else {
            const queryString = Object.entries(params)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');
            return request.get(`${host}${api_utilities_action}?${queryString}`);
        }
    },
    api_utilities_template() {
        return request.get(`${host}${api_utilities_template}`, {
            responseType: 'blob'
        });
    },
    api_utilities_batch_add(formData) {
        return request.post(`${host}${api_utilities_batch_add}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    api_utilities_payment_save: (data) => {
        return request({
            url: `${host}${api_utilities_payment_save}`,
            method: 'post',
            data: data
        });
    },
    api_utilities_payment_action(params, method = 'get') {
        if (method === 'DELETE') {
            return request.delete(`${host}${api_utilities_payment_action}`, {
                data: JSON.stringify(params),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        } else if (method === 'PUT') {
            return request.put(`${host}${api_utilities_payment_action}`, JSON.stringify(params), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        } else {
            const queryString = Object.entries(params)
                .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                .join('&');
            return request.get(`${host}${api_utilities_payment_action}?${queryString}`);
        }
    },
    api_utilities_check(params) {
        return request.post(`${host}${api_utilities_check}`, JSON.stringify(params), {
            headers: { 'Content-Type': 'application/json' }
        });
    },
    api_utilities_payment_template() {
        return request.get(`${host}${api_utilities_payment_template}`, {
            responseType: 'blob'
        });
    },
    api_utilities_payment_batch_add(formData) {
        return request.post(`${host}${api_utilities_payment_batch_add}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
}
